<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Quem Somos'" :novo="novo" :titulo="'quemSomos: ' + contentEdit.idioma" :icone="icone" />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-12 form-group">
          <label>Idioma:</label>
          <input
            type="text"
            v-model="contentEdit.idioma"
            name="idioma"
            id="idioma"
            class="form-control required valid"
            value
            
          />
        </div>

        <div class="clearfix"></div>
        <div class="col-12"> 
          <hr>
          <h4>Configurações Quem Somos</h4>
       </div>
        <div class="clearfix"></div>
        <div class="col-6 form-group">
          <label>Título</label>
          <input
            type="text"
            v-model="contentEdit.titulo"
            name="titulo"
            id="titulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-6 form-group">
          <label>Subtitulo</label>
          <input
            type="text"
            v-model="contentEdit.subTitulo"
            name="subTitulo"
            id="subTitulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="clearfix"></div>
        <div class="col-12"> 
          <hr>
          <h4>Configurações Sobre</h4>
       </div>
        <div class="col-6 form-group">
          <label>Título Sobre</label>
          <input
            type="text"
            v-model="contentEdit.sobreTitulo"
            name="sobreTitulo"
            id="sobreTitulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-6 form-group">
          <label>Subtítulo Sobre</label>
          <input
            type="text"
            v-model="contentEdit.sobreSubTitulo"
            name="sobreSubTitulo"
            id="sobreSubTitulo"
            class="form-control required valid"
            value
          />
        </div>
       <div class="col-sm-12">
            <h4 class="mb-3">Texto sobre</h4>
          <vue-editor class="vEditor" :editor-toolbar="customToolbar" v-model="contentEdit.sobreTexto" />
        </div>
          <div class="col-sm-6 offset-3 text-center">
            <label>Imagem sobre:</label>
          </div>
          <div class="col-12"></div>
          <div class="col-sm-6 offset-3 text-center">
           <div
              class="areaFoto"
              :class="contentEdit.sobreImagem? 'ativo':''"
              @click="$refs.sobreImagem.click()"
              :style="contentEdit.sobreImagem && carregado? 'background:url(' + contentEdit.sobreImagem+')':'background:url()'"
            >
              <i class="icon-cloud-upload-alt"></i>
              <input
                type="file"
                @change="OnFileSelected"
                id="sobreImagem"
                name="sobreImagem"
                ref="sobreImagem"
                style="display: none;"
                class="form-control"
                accept="image/*"
              />
            </div>
            <button
              v-if="contentEdit.sobreImagem"
              class="btn btn-danger"
              @click.prevent="fnRemoveFoto('sobreImagem',2)"
            >Remover foto</button>
          </div>

        <div class="clearfix"></div>
        <div class="col-12"> 
          <hr>
          <h4>Configurações Política</h4>
        </div>



        <div class="col-12 form-group">
          <label>Título política</label>
          <input
            type="text"
            v-model="contentEdit.politicaTitulo"
            name="politicaTitulo"
            id="politicaTitulo"
            class="form-control required valid"
            value
          />
        </div>
       <div class="col-sm-12">
            <h4 class="mb-3">Texto política</h4>
          <vue-editor class="vEditor" :editor-toolbar="customToolbar" v-model="contentEdit.politicaTexto" />
        </div>
        <div class="col-12"> 
          <hr>
          <h4>Outras configurações</h4>
        </div>

        <div class="col-6 form-group">
          <label>Título equipe</label>
          <input
            type="text"
            v-model="contentEdit.equipeTitulo"
            name="equipeTitulo"
            id="equipeTitulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-6 form-group">
          <label>Título destaque</label>
          <input
            type="text"
            v-model="contentEdit.destaqueTitulo"
            name="destaqueTitulo"
            id="destaqueTitulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12 form-group">
          <label>Frase destaque</label>
          <textarea
            v-model="contentEdit.destaqueFrase"
            name="destaqueTitulo"
            id="destaqueTitulo"
            class="form-control required valid"
            value          >

          </textarea>
        </div>


        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Cancelar</button>
          <button
           type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >Gravar</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Tbheader from "../_headerTabelas";
import { getData,getSuccess,getError,urlApi } from "../../global/utils";
import { VueEditor } from "vue2-editor";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: urlApi,
      suporteAtivo: true,
      success: false,
      error:null,
      contentFotos: [],
      carregado:true,
      files: [],
      sobreImagem: [],
      logotipoRodape: [],
      contentEdit: {
        titulo:'',
        ativo: false,
      },      
      customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ]

    };
  },
  components: { Tbheader,VueEditor  },
  methods: {
    OnFileSelected(event) {
      if (event.target.id == "sobreImagem") {
        this.contentEdit.sobreImagem = URL.createObjectURL(event.target.files[0]);
        this.sobreImagem = event.target.files[0];
       this.carregado = true;
      } 
    },
    fnRemoveFoto(tipo, i) {
      var filename = '';
        if (i == 1) {
          filename = this.contentEdit.sobreImagem.split('/').pop().split('#')[0].split('?')[0]
          this.contentEdit.sobreImagem = null;
        } 
      this.$http
        .delete("eoficinas/upload/eoficinas/quemSomos/" + this.contentEdit.idioma + "/" +filename +"/arquivo")
        .then((res) => {
          console.log(res);
        });

    },
   GetFilename(url)
    {
      if (url)
      {
          var m = url.toString().match(/.*\/(.+?)\./);
          if (m && m.length > 1)
          {
            return m[1];
          }
      }
      return "";
    },
    OnUpload() {
      let fd = new FormData();
      if(this.sobreImagem.name != undefined){
       fd.append("files", this.sobreImagem, this.sobreImagem.name);
      }
      if(this.logotipoRodape.name != undefined){
       fd.append("files", this.logotipoRodape, this.logotipoRodape.name);
      }
      this.$http
        .post("eoficinas/upload/eoficinas/" + this.contentEdit.idioma +"/quemSomos", fd)
        .then(() => {
          this.carregado = true;


        });
    },
    fnLimpa(){
      this.contentEdit.titulo = ''
      this.contentEdit.ativo = ''
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
          this.contentEdit.ativo = !this.contentEdit.ativo
    },
    fnCancela(){
        this.$router.push({path: `/eoficinas/quemSomos/`})
    },
    async formSubmit(e) {
        e.preventDefault();
        const metodo = this.$route.params.id ? 'put' : 'post'
        const completaUrl = this.$route.params.id ? "/" + this.$route.params.id : ''
      const imgUrl =
      urlApi + "Upload/eoficinas/"  + this.contentEdit.idioma + "/quemSomos/";
      var chamaUpload = false;
      if(this.sobreImagem.name != undefined){
        chamaUpload = true;
        this.contentEdit.sobreImagem  = imgUrl + this.sobreImagem.name;
      }

       let data = await this.$http[metodo]("/eoficinas/quemSomos" + completaUrl,this.contentEdit)
        .then(() =>{
           if(chamaUpload){
            this.OnUpload();
          }
           getSuccess();
            this.fnLimpa();
            this.fnCancela();
        })
       .catch(e => {
        return  e
        }); 
        this.error = data
        

    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi+"eoficinas/quemSomos/"+valueId);
      this.contentEdit = data[0].content;
      this.fnCarregaIdiomas(valueId);
      this.$vs.loading.close()
    },   
    async fnCarregaIdiomas(valueId) {
      let data = await getData(this.urlApi+"eoficinas/idiomas/"+valueId);
      console.log(data);
      this.contentEdit.idioma = data[0].content.abreviacao;
    },   

  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#editor1,#editor2,#editor3{
	min-height: 50vh;
}
</style>